module.exports = __webpack_public_path__ + "static/media/face-with-rolling-eyes-svgrepo-com.0c696ff8.svg";